module.exports = __webpack_public_path__ + "img/folder-not-empty.2769915b.svg";